import React from "react"
import img from "../headerImage.png"
import mobileImg from "../sensorWallMobile.png"

export function HeroHeader(): React.JSX.Element {
    return (
        <>
            <style>{`
                .hero-header {
                    background-image: url(${img});
                    align-items: center;
                }

                .hero-title {
                    font-size: clamp(32px, 7vw, 80px);
                    margin-bottom: clamp(12px, 3vw, 20px);
                    font-weight: 500;
                    line-height: 1.2;
                }

                .hero-button {
                    display: inline-block;
                }

                @media (max-width: 768px) {
                    .hero-header {
                        background-image: url(${mobileImg});
                        align-items: flex-end !important;
                        padding-bottom: 40px;
                        box-sizing: border-box;
                    }

                    .hero-title {
                        font-size: 42px;
                    }

                    .hero-button {
                        width: 100%;
                    }

                  .hero-button button {
                        width: 100%;
                        padding: 15px 32px !important;
                        font-size: 18px !important;
                    }
                }
            `}</style>

            <header
                className="hero-header"
                style={{
                    position: "relative",
                    width: "100%",
                    height: "100svh",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    justifyContent: "flex-start",
                    color: "white",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.1)",
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                        maxWidth: "800px",
                        padding: "0 clamp(20px, 5vw, 60px)",
                        textAlign: "left",
                        boxSizing: "border-box",
                    }}
                >
                    <h1 className="hero-title">
                        Optimized sensor <br /> solutions for you{" "}
                    </h1>
                    <p
                        style={{
                            fontSize: "clamp(14px, 2vw, 17px)",
                            marginBottom: "clamp(20px, 4vw, 30px)",
                            lineHeight: "1.6",
                            color: "#f5f5f5",
                            maxWidth: "600px",
                        }}
                    >
                        You can't manage what you don't measure. Measure everything with our sensor system. We offer both
                        standard products specializing in air quality and energy measurements and specialized solutions
                    </p>
                    <a href="#contact" className="hero-button">
                        <button
                            style={{
                                padding: "clamp(8px, 2vw, 10px) clamp(18px, 4vw, 24px)",
                                fontSize: "clamp(13px, 2vw, 14px)",
                                fontWeight: "600",
                                color: "#000",
                                backgroundColor: "#fff",
                                border: "none",
                                borderRadius: "24px",
                                cursor: "pointer",
                                transition: "background 0.3s ease",
                            }}
                            onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#e8e8e8")}
                            onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#fff")}
                        >
                            Contact us
                        </button>
                    </a>
                </div>
            </header>
        </>
    )
}